import axios from 'axios';
import { applyAuthInterceptors } from './authInterceptors';

const rawBase = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '');

const httpClient = axios.create(
  rawBase
    ? { baseURL: rawBase }
    : {}
);

applyAuthInterceptors(httpClient);

export { httpClient };
export default httpClient;
